<template>
  <div
    :class="{'emphasized' : isEmphasized}"
    class="standard-filter-input"
  >
    <el-input
      ref="inputRef"
      v-model="internalValue"
      :placeholder="placeholder"
      :maxlength="maxlength"
      size="default"
      autosize
      @keydown.enter.prevent="submit"
      @focus="$emit('focus')"
      @blur="submit"
    />
  </div>
</template>
<script lang="ts">
/* General */
import { defineComponent } from 'vue'

/* Mixins */

/* Components */

/* Helpers */

/* Data types */

/* API */

export default defineComponent({
  name: 'StandardFilterInput',

  props: {
    modelValue: {
      type: [String, Number, Object, Array],
      default: '',
    },
    maxlength: {
      type: String,
      required: false,
      default: null,
    },
    placeholder: {
      type: String,
      required: true,
    },
    isFocused: {
      type: Boolean,
      default: false,
    },
    isEmphasized: {
      type: Boolean,
      default: false,
    },
  },

  emits: ['blur', 'focus', 'input-submitted', 'update:modelValue'],

  computed: {
    internalValue: {
      get(): any {
        return this.modelValue
      },
      set(value: any): any {
        this.$emit('update:modelValue', value)
      },
    },
  },

  watch: {
    isFocused: {
      handler(newValue) {
        if (this.$refs.inputRef !== undefined && newValue) {
          // @ts-ignore
          this.$refs.inputRef.focus()
        }
      },
    },
  },

  mounted() {
    if (this.isFocused) {
      // @ts-ignore
      this.$refs.inputRef.focus()
    }
  },

  methods: {
    submit() {
      this.$emit('blur')
      this.$emit('input-submitted', this.internalValue)
    },
  },
})
</script>
<style lang="scss">
.standard-filter-input {
  display: flex;

  .el-input {
    @include disable-select;

    &__inner {
      @include lettering--p-sm;
    }

    &::-ms-clear {
      display: none;
    }
  }

  &.emphasized .el-input__wrapper {
    background-color: var(--color-background-blue-15);
    box-shadow: 0 0 0 1px $color--blue-60 inset;
  }
}
</style>
